import { convertDataTypeBooleanToString } from "../../../../shared/utils/convertDataTypeBoolean";
import { AttributeDataType, CustomField } from "@wingspanhq/wingspan-api-sdk";

export function getCustomFieldsLabelsRequest(
  formFields: CustomField[],
  values: { [key: string]: any }
) {
  const labels: any = {};
  formFields.forEach(field => {
    if (!field.key) {
      return;
    }
    const key = field.key;

    switch (field.dataType) {
      case AttributeDataType.STRING:
        labels[key] = values[key] ? String(values[key]) : "";
        break;

      case AttributeDataType.BOOLEAN:
        labels[key] = convertDataTypeBooleanToString(values[key]);
        break;
    }
  });
  return labels;
}
